import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      color={color}
      fontSize={size}
      style={style}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="nonzero"
        d="M5.30643473,1.66499624 C6.41673196,-0.555198752 9.58346804,-0.555198752 10.6938136,1.6650929 L10.6938136,1.6650929 L15.6788136,11.6386847 C16.6800298,13.6418385 15.2233112,15.9998621 12.9846,15.9998621 L12.9846,15.9998621 L3.0156,15.9998621 C0.776178373,15.9998621 -0.679959373,13.6420977 0.321386405,11.6386847 L0.321386405,11.6386847 Z M9.79943473,2.11256427 C9.05773196,0.629425583 6.94246804,0.629425583 6.2008136,2.11246761 L6.2008136,2.11246761 L1.2158136,12.0860594 C0.546880069,13.4244084 1.51964605,14.9995018 3.0156,14.9995018 L3.0156,14.9995018 L12.9846,14.9995018 C14.4799134,14.9995018 15.4531592,13.4240868 14.7843864,12.0860594 L14.7843864,12.0860594 Z M8,11.9786139 C8.345,11.9786139 8.625,12.2587148 8.625,12.6038391 C8.625,12.9489634 8.345,13.2290642 8,13.2290642 C7.655,13.2290642 7.375,12.9489634 7.375,12.6038391 C7.375,12.2587148 7.655,11.9786139 8,11.9786139 Z M8,4.97909317 C8.27614237,4.97909317 8.5,5.20303144 8.5,5.4792733 L8.5,5.4792733 L8.5,10.5200886 C8.5,10.7963305 8.27614237,11.0202688 8,11.0202688 C7.72385763,11.0202688 7.5,10.7963305 7.5,10.5200886 L7.5,10.5200886 L7.5,5.4792733 C7.5,5.20303144 7.72385763,4.97909317 8,4.97909317 Z"
      />
    </svg>
  );
}
